import { useEffect, useState } from 'react';

const MEDIA_MATCHES = {
  isPhablet: `(max-width: 768px)`,
  isLaptop: `(min-width: 769px) and (max-width: 1439px)`,
  isPc: `(min-width: 1440px) and (max-width: 1919px)`,
  isQHD: `(min-width: 1920px) and (max-width: 2440px)`,
  is4k: `(min-width: 2441px) `,
} as const;

type QUERY = keyof typeof MEDIA_MATCHES;

export default function useMatchMedia(
  query: QUERY,
  elementWindow = window as Window,
) {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () =>
      setMatches(elementWindow.matchMedia(MEDIA_MATCHES[query]).matches);

    handleResize();
    elementWindow.addEventListener('resize', handleResize);

    return () => {
      elementWindow.removeEventListener('resize', handleResize);
    };
  }, [query, elementWindow]);

  return matches;
}
